import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import MuiButton from '@mui/material/Button';
import { TextInput } from '../../../../../ui/input/text_input/text_input';
import { SelectPermissions } from './select_permissions';

type AddRoleModalProps = {
  entities: string[];
  addRole: (roleName: string, permissions: string[]) => void;
};

const actions: string[] = ['create', 'edit', 'delete', 'view'];

function AddRoleModal({ entities, addRole }: AddRoleModalProps): JSX.Element {
  const [selectedActions, setSelectedActions] = useState<string[]>([]);
  const [roleName, setRoleName] = useState<string>('');

  return (
    <Stack spacing={2.5} sx={{ width: '100%', pt: 1 }}>
      <Box sx={{ width: { xs: '100%', sm: '80%' } }}>
        <TextInput
          name='roleName'
          value={roleName}
          type='text'
          label='Role Name'
          onChange={(event) => setRoleName(event.target.value)}
        />
      </Box>
      <SelectPermissions
        selectedActions={selectedActions}
        setSelectedActions={setSelectedActions}
        entities={entities}
        actions={actions}
      />
      <Box sx={{ display: 'flex', justifyContent: 'flex-start' }}>
        <MuiButton
          onClick={() => addRole(roleName, selectedActions)}
          variant='contained'
          sx={{
            borderRadius: '6px',
            textTransform: 'none',
            fontWeight: 600,
            bgcolor: '#093725',
            '&:hover': { bgcolor: '#062619' },
          }}
        >
          Add Role
        </MuiButton>
      </Box>
    </Stack>
  );
}

export default AddRoleModal;
